<template>
  <div>
    <EditProductSidebar
      :isSidebarActive="openEditProductSidebar"
      @closeSidebar="toggleEditProductSidebar"
      :editProductData="editProductData"
      @getAllProduct="getAllProduct"
    />
    <modal :show.sync="editModal" header-classes="bg-primary p-3" size="lg">
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        ADD IMAGE
      </h6>
      <AddPageDetail />
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button type="secondary" class="ml-auto" @click="editModal = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <!-- addproductdetails -->
    <modal
      :show.sync="ShowProductDetails"
      header-classes="bg-primary p-3"
      size="lg"
    >
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        ADD PRODUCT DETAILS
      </h6>
      <AddProductDetails />
      <template slot="footer">
        <base-button type="primary" class="hover:text-black"
          >SUBMIT</base-button
        >
        <base-button
          type="secondary"
          class="ml-auto"
          @click="ShowProductDetails = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <!--Edit Product -->
    <modal
      :show.sync="ShowEditProduct"
      header-classes="bg-primary p-3"
      size="lg"
    >
      <h6
        slot="header"
        class="modal-title text-white modal-close-btn font-semibold pt-1"
      >
        EDIT
      </h6>
      <!-- <EditProduct /> -->
      <template slot="footer">
        <base-button type="primary">SUBMIT</base-button>
        <base-button
          type="secondary"
          class="ml-auto"
          @click="ShowEditProduct = false"
          >CLOSE</base-button
        >
      </template>
    </modal>

    <b-card class="rounded-2xl mb-4 cust-shadow cardbody-p">
      <div class="row">
        <div class="col-sm-3">
          <img
            v-if="item.productImage"
            :src="`${$imageURL}/${item.productImage}`"
            class="rounded-lg"
            :alt="item.name"
          />
          <img v-else :src="$noIMG" class="rounded-lg" :alt="item.name" />
        </div>

        <div class="col-sm-6 py-2 pl-2">
          <div>
            <p class="font-bold">{{ item.name }}</p>
            <!-- <small class="text-muted ellipsis-3">{{ item.description }}</small> -->
            <small class="text-muted ellipsis-3"
              ><b>{{
                item.brandData.length ? item.brandData[0].name : item.brand
              }}</b></small
            >
          </div>
          <div class="mt-4">
            <div class="color">
              <p class="font-semibold text-md rounded-full">
                Price:
                <span class="ml-2 text-base font-semibold"
                  >&#8377; {{ item.price }}</span
                >
              </p>
            </div>
            <div class="color" v-if="item.discount">
              <p class="font-semibold text-md rounded-full">
                Discount:
                <span class="ml-2 text-base font-semibold"
                  >{{ item.discount }}%</span
                >
              </p>
            </div>
            <div class="color" v-if="item.couponCode">
              <p class="font-semibold text-md rounded-full">
                Coupon Code:
                <span class="ml-2 text-base font-semibold">{{
                  item.couponCode
                }}</span>
              </p>
            </div>
            <div class="color" v-if="item.hasOwnProperty('isURL')">
              <p class="font-semibold text-md rounded-full" v-if="item.isURL">
                URL:
                <span class="ml-2 text-base font-semibold">{{ item.url }}</span>
              </p>
              <p class="font-semibold text-md rounded-full" v-else>
                SKU:
                <span class="ml-2 text-base font-semibold">{{ item.sku }}</span>
              </p>
            </div>
            <div class="color" v-else>
              <p class="font-semibold text-md rounded-full">
                URL:
                <span class="ml-2 text-base font-semibold">{{ item.url }}</span>
              </p>
            </div>
          </div>
        </div>
        <div
          class="col-sm-3 flex items-center justify-center"
          v-if="item.adminApproval == 'pending'"
        >
          <div class="pr-4">
            <base-button
              outline
              type="primary"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              @click="approveStatus(item, 'approved')"
            >
              Approve
            </base-button>
            <base-button
              outline
              type="danger"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              @click="approveStatus(item, 'rejected')"
            >
              Reject
            </base-button>
          </div>
        </div>
        <div
          class="col-sm-3 flex items-center justify-center"
          v-else-if="item.adminApproval == 'approved'"
        >
          <div class="pr-4">
            <base-button
              type="primary"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              disabled
            >
              Approved
            </base-button>
            <base-button
              outline
              type="danger"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              @click="approveStatus(item, 'rejected')"
            >
              Reject
            </base-button>
          </div>
        </div>
        <div
          class="col-sm-3 flex items-center justify-center"
          v-else-if="item.adminApproval == 'rejected'"
        >
          <div class="pr-4">
            <base-button
              outline
              type="primary"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              @click="approveStatus(item, 'approved')"
            >
              Approve
            </base-button>
            <base-button
              type="danger"
              class="mb-2 w-full py-2 text-xs hover:text-white"
              disabled
            >
              Rejected
            </base-button>
          </div>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import AddPageDetail from "./AddPageDetail";
import AddProductDetails from "./AddProductDetails";

import EditProductSidebar from "./EditProductSidebar.vue";
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    currentPage: {
      type: Number,
    },
  },
  components: {
    AddPageDetail,
    AddProductDetails,

    EditProductSidebar,
  },
  data() {
    return {
      openEditProductSidebar: false,

      selectedItem: 1,
      selectedSize: null,
      editModal: false,
      ShowProductDetails: false,
      ShowEditProduct: false,
      editProductData: {},
    };
  },

  methods: {
    async getProducts() {
      this.$emit("getAllProduct");
    },
    async approveStatus(row, val) {
      // console.log(row);
      let loader;
      const payload = new FormData();
      payload.append("productId", row._id);
      payload.append("adminApproval", val);
      payload.append("isUrl", "false");
      payload.append("discount", row.discount);
      loader = this.$loading();
      try {
        const data = await this.$store.dispatch(
          "affiliate/updateProduct",
          payload
        );
        this.getProducts();
        loader.close();
        if (data.code === 200) {
          if (val == "false") {
            await this.$swal({
              text: "Product successfully Rejected",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          } else {
            await this.$swal({
              text: "Product successfully Approved",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#830c81",
            });
          }
        }
      } catch (err) {
        console.log(err);
        loader.close();
      }
    },
  },
};
</script>

<style scoped>
.active-color {
  border: 1px solid black;
}
.form-group {
  margin-bottom: 0 !important;
}
</style>
